// Mock data for King of IT Group website

export const companyInfo = {
  name: "King of IT Group",
  tagline: "Enterprise Technology Solutions & Cybersecurity",
  description: "Transform your business with comprehensive IT infrastructure management and enterprise-grade cybersecurity solutions. We deliver measurable results through strategic technology partnerships.",
  phone: {
    support: "(647) 951-3653"
  },
  email: "info@kingofitgroup.ca",
  domain: "kingofitgroup.ca",
  established: "2010",
  location: "Ontario, Canada"
};

export const navLinks = [
  { label: "Services", href: "#services", hasDropdown: true },
  { label: "About Us", href: "#about", hasDropdown: true },
  { label: "Industries", href: "#industries", hasDropdown: true },
  { label: "Blog", href: "#blog" },
  { label: "Locations", href: "#locations", hasDropdown: true },
  { label: "Contact Us", href: "#contact", hasDropdown: true }
];

export const partners = [
  { name: "Microsoft", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Microsoft_logo.svg/512px-Microsoft_logo.svg.png" },
  { name: "Cisco", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Cisco_logo_blue_2016.svg/1200px-Cisco_logo_blue_2016.svg.png" },
  { name: "Dell", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Dell_Logo.svg/1200px-Dell_Logo.svg.png" },
  { name: "HP", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/HP_logo_2012.svg/1200px-HP_logo_2012.svg.png" },
  { name: "Fortinet", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Fortinet_logo.svg/1200px-Fortinet_logo.svg.png" },
  { name: "Lenovo", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Lenovo_logo_2015.svg/1200px-Lenovo_logo_2015.svg.png" },
  { name: "Samsung", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/Samsung_Logo.svg/1200px-Samsung_Logo.svg.png" },
  { name: "Google", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/1200px-Google_2015_logo.svg.png" }
];

export const services = [
  {
    id: 1,
    title: "Cybersecurity Solutions",
    description: "Comprehensive threat detection, vulnerability assessments, and incident response protocols. Our multi-layered security framework protects your critical assets against evolving cyber threats.",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&h=400&fit=crop",
    icon: "Shield"
  },
  {
    id: 2,
    title: "IT Infrastructure Management",
    description: "End-to-end infrastructure oversight including network architecture, server administration, and performance optimization. Reduce operational complexity while maximizing system reliability.",
    image: "https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?w=600&h=400&fit=crop",
    icon: "Users"
  },
  {
    id: 3,
    title: "Managed Services",
    description: "Proactive 24/7 monitoring, predictive maintenance, and rapid incident resolution. Our dedicated team ensures your technology environment operates at peak performance.",
    image: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=600&h=400&fit=crop",
    icon: "Settings"
  },
  {
    id: 4,
    title: "Cloud Architecture",
    description: "Strategic cloud migration, hybrid environment design, and ongoing optimization. Leverage scalable infrastructure to drive agility and reduce capital expenditure.",
    image: "https://images.unsplash.com/photo-1568952433726-3896e3881c65?w=600&h=400&fit=crop",
    icon: "Cloud"
  },
  {
    id: 5,
    title: "Business Communications",
    description: "Integrated voice, video, and collaboration platforms that enhance productivity. Seamless connectivity solutions designed for the modern distributed workforce.",
    image: "https://images.pexels.com/photos/356056/pexels-photo-356056.jpeg?w=600&h=400&fit=crop",
    icon: "MessageSquare"
  }
];

export const stats = [
  { value: "500", suffix: "+", label: "Enterprise Clients" },
  { value: "15", suffix: "+", label: "Years of Excellence" },
  { value: "99.9", suffix: "%", label: "Uptime Guarantee" },
  { value: "24", suffix: "/7", label: "Support Availability" }
];

export const industries = [
  {
    id: 1,
    title: "Manufacturing",
    description: "Optimize production workflows with industrial IoT integration, real-time monitoring systems, and secure operational technology networks that drive efficiency.",
    icon: "Cog"
  },
  {
    id: 2,
    title: "Legal & Financial Services",
    description: "Ensure regulatory compliance with secure document management, encrypted communications, and audit-ready infrastructure designed for sensitive data handling.",
    icon: "Scale"
  },
  {
    id: 3,
    title: "Healthcare",
    description: "PHIPA-compliant solutions protecting patient data integrity. Secure electronic health records, telemedicine platforms, and medical device integration.",
    icon: "Heart"
  },
  {
    id: 4,
    title: "Education",
    description: "Enable digital learning environments with secure campus networks, learning management system integration, and scalable infrastructure for institutional growth.",
    icon: "GraduationCap"
  },
  {
    id: 5,
    title: "Government & Public Sector",
    description: "Meet stringent security requirements with Canadian data residency, comprehensive compliance frameworks, and transparent governance protocols.",
    icon: "Building"
  },
  {
    id: 6,
    title: "Non-Profit Organizations",
    description: "Maximize your impact with cost-effective technology solutions, grant-compliant reporting systems, and donor management platform integration.",
    icon: "HandHeart"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "David Morrison",
    company: "Morrison & Associates LLP",
    rating: 5,
    text: "King of IT Group transformed our firm's technology infrastructure. Their proactive approach to cybersecurity and responsive support team has given us complete confidence in our systems. Exceptional service delivery."
  },
  {
    id: 2,
    name: "Patricia Nguyen",
    company: "Precision Manufacturing Corp.",
    rating: 5,
    text: "The operational improvements since partnering with King of IT have been substantial. Their team understood our manufacturing processes and implemented solutions that directly impacted our bottom line. Highly recommended."
  },
  {
    id: 3,
    name: "Dr. James Crawford",
    company: "Crawford Medical Centre",
    rating: 5,
    text: "Patient data security is paramount in healthcare. King of IT Group implemented a comprehensive compliance framework that exceeds regulatory requirements while streamlining our clinical workflows."
  },
  {
    id: 4,
    name: "Amanda Richardson",
    company: "Richardson Financial Group",
    rating: 5,
    text: "Their strategic approach to IT planning has been invaluable. King of IT Group doesn't just solve problems—they anticipate them. Our technology now aligns perfectly with our business objectives."
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "The Strategic Value of Managed IT Services for Growing Enterprises",
    date: "January 15, 2025",
    image: "https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=400&h=250&fit=crop"
  },
  {
    id: 2,
    title: "Navigating Digital Transformation: A Framework for Canadian Businesses",
    date: "December 8, 2024",
    image: "https://images.unsplash.com/photo-1568952433726-3896e3881c65?w=400&h=250&fit=crop"
  },
  {
    id: 3,
    title: "Zero Trust Architecture: Building Resilient Security Postures",
    date: "November 22, 2024",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=400&h=250&fit=crop"
  },
  {
    id: 4,
    title: "Cloud Migration Strategies: Minimizing Risk While Maximizing ROI",
    date: "October 30, 2024",
    image: "https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5?w=400&h=250&fit=crop"
  },
  {
    id: 5,
    title: "Incident Response Planning: Preparing for Cyber Threats",
    date: "September 18, 2024",
    image: "https://images.unsplash.com/photo-1590065707046-4fde65275b2e?w=400&h=250&fit=crop"
  },
  {
    id: 6,
    title: "Leveraging AI and Automation in IT Operations",
    date: "August 25, 2024",
    image: "https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg?w=400&h=250&fit=crop"
  }
];

export const aboutContent = {
  title: "Strategic Technology Partnership",
  paragraphs: [
    "Since 2010, King of IT Group has established itself as a trusted technology partner for enterprises across Ontario. We combine deep technical expertise with strategic business acumen to deliver solutions that drive measurable outcomes.",
    "Our methodology centers on understanding your unique operational requirements and aligning technology investments with your organizational objectives. We don't simply provide IT services—we engineer competitive advantages.",
    "As a Canadian-owned enterprise, we maintain the highest standards of data governance and regulatory compliance. Our commitment to excellence has earned the trust of over 500 organizations across diverse industries."
  ],
  image: "https://images.unsplash.com/photo-1664575602276-acd073f104c1?w=600&h=450&fit=crop"
};

export const ctaBannerImage = "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&h=400&fit=crop";

export const contactImage = "https://images.pexels.com/photos/3184416/pexels-photo-3184416.jpeg?w=500&h=600&fit=crop";
